const colors = {
  secondary: {
    light: "#00d4ff",
    dark: "#0099cc",
  },
  primary: "#00ff6a",
  dark: "#c8ccd4",
  white: "#fff",
  light: "#1a1d27",
  stone: "#2a2d3a",
  black: "#000",
  bg: "#090b10",
  bgCard: "#0f1218",
  bgElevated: "#141820",
  muted: "#6b7280",
  accent: "#ff3d71",
};

export default colors;
